export default __webpack_public_path__ + "static/shoecoveranti-108e7bd680c1f36843e897331207690d.jpg";